const eventsLog = 'eventsLog';

/** Base Fetch Actions */
export const FETCH_EVENTS_LOG_RESPONSE = `${eventsLog}/FETCH_EVENTS_LOG_RESPONSE` as const;
export const FETCH_EVENTS_LOG_REQUEST = `${eventsLog}/FETCH_EVENTS_LOG_REQUEST` as const;
